<script lang="ts">
  import { defang } from '$lib/protocol/link-guard';
  import type { AnswerElement } from '$lib/protocol/types';

  let { element }: { element: AnswerElement } = $props();
</script>

<!-- Bound to its question by question_id, not by adjacency — rendered as plain
     text; the pairing matters to the server, not to the reader. -->
<p class="answer">{defang(element.text)}</p>

<style>
  .answer {
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
</style>
